import register from '../util/init'
import { debounce } from './tools'

function onSearchChange (e) {
  const table = document.querySelector('.portfolio-list__table')
  let id = 'self'
  if (window.location.pathname.split('/')[1] === 'firms') {
    id = 'all'
  }
  if (window.location.pathname.split('/')[1] === 'advisers') {
    id = window.location.pathname.split('/')[2]
  }
  let value = e.target.value
  let sort = 'name'
  if (e.target.value === '' || e.target.value === '%20') {
    value = 'all'
    sort = 'fum'
  }

  value = encodeURIComponent(value)
  window.fetch(
    encodeURI(`/portfolio/get/?id=${id}&search=${value}&sort=${sort}&limit=10`),
    {
      credentials: 'include'
    }
  )
    .then(response => {
      return response.json()
    })
    .then(JsonResponse => {
      table.innerHTML = JsonResponse.table_template
    })
}

function dashboardPortfolios (container) {
  const portfoliosSearch = document.querySelector('.filters__search')

  const portfoliosSearchIcon = document.querySelector('.portfolios__filters--search')
  portfoliosSearchIcon.addEventListener('click', e => {
    portfoliosSearch.classList.toggle('active')
  })

  portfoliosSearch.addEventListener('keyup', debounce(e => onSearchChange(e), 300))
}

register('.portfolio-list.top-five', dashboardPortfolios)



// WEBPACK FOOTER //
// ./assets/j/src/dashboard_portfolios.js